import { Box } from '@mui/material';
import React from 'react';

interface Props {
  height?: string;
  contents?: string;
  isNoBorder?: boolean;
}

export const NoDataPage: React.FC<Props> = ({
  height,
  contents,
  isNoBorder,
}: Props) => (
  <>
    <Box
      className={`no-data ${isNoBorder ? 'no_border' : ''}`}
      style={{ height }}
    >
      <div>{contents ?? '데이터가 없습니다.'}</div>
    </Box>
  </>
);

export default NoDataPage;
